import React from "react";
import { motion } from "framer-motion";

const ServicesCard = ({ icons, title, subTitle }) => {
  return (
    <motion.div
      whileHover={{ y: -5 }}
      className="mt-3 py-8 px-6 flex flex-col items-center gap-6 bg-gray-800 rounded-xl border border-gray-700 hover:bg-gray-700 transition-colors"
    >
      <span className="text-4xl text-blue-400 mb-2">{icons}</span>
      <h2 className="font-semibold text-xl text-gray-200">{title}</h2>
      <p className="text-base text-center text-gray-400">{subTitle}</p>
    </motion.div>
  );
};

export default ServicesCard;